import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    connect() {
        console.log("remote model connected")
        this.modal = new Modal(this.element)
        this.modal.show()
    }

    disconnect() {
        this.element.closest("turbo-frame")?.reload()
        this.element.remove()
        // super.disconnect();
    }

    hideBeforeRender(event) {
        console.log("Hide model")
        if(window.location.pathname.includes('/v2/schedules') || window.location.pathname.includes('/v2/playlists') || window.location.pathname.includes('/v2/displays')){
            window.location.reload();
        }
        if (this.isOpen()) {
            event.preventDefault()
            this.element.addEventListener('hidden.bs.modal', event.detail.resume)
            this.modal.hide()
        }
    }

    beforeCache() {
        if (this.isOpen()) {
            this.modal.hide()
        }
        const frame = this.element.closest("turbo-frame")
        if (frame) frame.innerHTML = ""
    }

    isOpen() {
        return this.element.classList.contains("show")
    }
}